angular.module('bmsApp.settings').controller('MinPayValueCtrl', [
	'$scope',
	'$log',
	'$q',
	'AppSettingsSvc',
	'notify',
	'LicenseOptionsSvc',
	'LicenseDetailSvc',
	'InstanceSvc',
	function ($scope, $log, $q, AppSettingsSvc, notify, LicenseOptionsSvc, LicenseDetailSvc, InstanceSvc) {

		$scope.settingData = {};
		$scope.loaded = false;
		$scope.options = {};
		$scope.handlers = {};
		$scope.form = {};

		$scope.ecomEnabled = InstanceSvc.instance.ecomEnabled();
		console.log('ecomEnabled', $scope.ecomEnabled);

		let promises = {
			settings: AppSettingsSvc.index(),
			licenses: LicenseOptionsSvc.license(),
		};

		$q.all(promises).then((responses) => {
			$scope.settingData = responses.settings.data.settings;
			$scope.options.licenses = responses.licenses.data.options;
			$scope.loaded = true;
		});

		$scope.submit = function (settingData) {
			var promise;
			promise = AppSettingsSvc.update(settingData);

			promise.then(function (response) {
				notify({
					message: 'Settings saved'
				});
			}, function (error) {
				$scope.errors = error;
			});

		};

		// Yes, i know this is shit, but then the whole thing needs re-writing!
		$scope.submit2 = function (settingData) {
			LicenseDetailSvc.saveMinJobValue($scope.form.selected_license).then((response) => {
				notify({
					message: 'Updated licence min job value',
				});
			});
		};


		$scope.handlers.licenseChanged = () => {
			LicenseDetailSvc.read($scope.form.license.id).then((response) => {
				$scope.form.selected_license = response.data.license;
			});
		}



	}]);
